import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const BoxChartContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 18px;
	@media screen and (max-width: ${ScreenSize.tablet}px) {
		flex-direction: column;
	}
`;

export const BoxChart = styled.div`
	width: calc(33% - calc(51px / 2));
	@media screen and (max-width: ${ScreenSize.tablet}px) {
        margin-bottom: 20px;
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        margin-bottom: 20px;
    }
	@media screen and (max-width: ${ScreenSize.tablet}px) {
		width: 100%;
	}
`;

export const ChatsContainer = styled.div`
	margin: 0 -20px;
`;
